//auth
export const FETCH_USER = 'FETCH_USER';
export const FETCH_LOGIN = 'FETCH_LOGIN';
export const IS_LOGGED_IN = 'IS_LOGGED_IN';
//elastic
export const FETCH_ALL_UNPROCESSED = 'FETCH_ALL_UNPROCESSED';
export const FETCH_ALL_UNPROCESSED_BY_FILTERS = 'FETCH_ALL_UNPROCESSED_BY_FILTERS';
//transactions
export const FETCH_TRANSACTIONS_BY_FILTERS = 'FETCH_TRANSACTIONS_BY_FILTERS';
export const FETCH_TRANSACTION_BY_ID = 'FETCH_TRANSACTION_BY_ID';
//products
export const FETCH_ALL_PRODUCTS = 'FETCH_ALL_PRODUCTS';
export const FETCH_PRODUCT_BY_ID = 'FETCH_PRODUCT_BY_ID';
export const FETCH_RANDOM_PRODUCTS = 'FETCH_RANDOM_PRODUCTS';
export const FETCH_PRODUCT_MATCHES_BY_GTIN = 'FETCH_PRODUCT_MATCHES_BY_GTIN';
//brands
export const FETCH_BRAND_BY_ID = 'FETCH_BRAND_BY_ID';
//retailers
export const FETCH_ALL_PARTNERS = 'FETCH_ALL_PARTNERS';
export const FETCH_PARTNER_BY_ID = 'FETCH_PARTNER_BY_ID';
export const FETCH_ALL_RETAILERS = 'FETCH_ALL_RETAILERS';
export const FETCH_RETAILER_BY_ID = 'FETCH_RETAILER_BY_ID';
//distributors
export const FETCH_ALL_DISTRIBUTORS = 'FETCH_ALL_DISTRIBUTORS';
export const FETCH_DISTRIBUTOR_BY_ID = 'FETCH_DISTRIBUTOR_BY_ID';
//pos users
export const FETCH_POS_USERS_BY_RETAILER_ID = 'FETCH_POS_USERS_BY_RETAILER_ID';
export const FETCH_POS_USER_BY_ID = 'FETCH_POS_USER_BY_ID';
//end users
export const FETCH_ALL_END_USERS = 'FETCH_ALL_END_USERS';
export const FETCH_END_USER_BY_ID = 'FETCH_END_USER_BY_ID';
export const FETCH_TRANSACTIONS_FOR_END_USER = 'FETCH_TRANSACTIONS_FOR_END_USER';
export const FETCH_INSURANCE_POLICY_BY_NUMBER = 'FETCH_INSURANCE_POLICY_BY_NUMBER';
export const FETCH_CARD_WITH_PAYMENT_PLAN = 'FETCH_CARD_WITH_PAYMENT_PLAN';
//fiscal bills
export const FETCH_ALL_FISCAL_BILLS_BY_FILTERS = 'FETCH_ALL_FISCAL_BILLS_BY_FILTERS';
export const FETCH_FISCAL_BILL_BY_PFR = 'FETCH_FISCAL_BILL_BY_PFR';
export const FETCH_FISCAL_BILL_BY_ID = 'FETCH_FISCAL_BILL_BY_ID';
//fiscal item claims
export const FETCH_ALL_FISCAL_ITEM_CLAIMS_BY_FILTERS = 'FETCH_ALL_FISCAL_ITEM_CLAIMS_BY_FILTERS';
export const FETCH_FISCAL_ITEM_CLAIM_BY_ID = 'FETCH_FISCAL_ITEM_CLAIM_BY_ID';
//contractors
export const FETCH_ALL_RISK_CONTRACTORS = 'FETCH_ALL_RISK_CONTRACTORS';
export const FETCH_CONTRACTORS_BY_FILTERS = 'FETCH_CONTRACTORS_BY_FILTERS';
export const FETCH_CONTRACTOR_BY_ID = 'FETCH_CONTRACTOR_BY_ID';
export const FETCH_CONTRACTOR_BY_PIN = 'FETCH_CONTRACTOR_BY_PIN';
export const FETCH_RISK_CONTRACTOR_BY_JMBG = 'FETCH_RISK_CONTRACTOR_BY_JMBG';
//admin users
export const FETCH_ADMIN_USERS_BY_FILTERS = 'FETCH_ADMIN_USERS_BY_FILTERS';
export const FETCH_ADMIN_USER_BY_ID = 'FETCH_ADMIN_USER_BY_ID';
export const FETCH_INTERNAL_AGENTS_BY_FILTERS = 'FETCH_INTERNAL_AGENTS_BY_FILTERS';
export const FETCH_EXTERNAL_AGENTS_BY_FILTERS = 'FETCH_EXTERNAL_AGENTS_BY_FILTERS';

//partners
export const FETCH_ALL_PARTNER_USERS = 'FETCH_ALL_PARTNER_USERS';
export const FETCH_PARTNER_USER_BY_ID = 'FETCH_PARTNER_USER_BY_ID';
//tags
export const FETCH_ALL_TAGS = 'FETCH_ALL_TAGS';
export const FETCH_TAG_BY_ID = 'FETCH_TAG_BY_ID';
//categories
export const FETCH_ALL_CATEGORIES = 'FETCH_ALL_CATEGORIES';
export const FETCH_CATEGORY_BY_ID = 'FETCH_CATEGORY_BY_ID';
//pages
export const FETCH_ALL_PAGES = 'FETCH_ALL_PAGES';
export const FETCH_PAGE_BY_ID = 'FETCH_PAGE_BY_ID';
//posts
export const FETCH_ALL_POSTS = 'FETCH_ALL_POSTS';
export const FETCH_POST_BY_ID = 'FETCH_POST_BY_ID';
//banners
export const FETCH_ALL_BANNERS = 'FETCH_ALL_BANNERS';
export const FETCH_BANNER_BY_ID = 'FETCH_BANNER_BY_ID';
